import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify);
const opts = {
  icons: {
    iconfont: 'mdiSvg',
  },
}
export default new Vuetify({
});
